/*LIBRARY*/
import { connect } from "react-redux";
import { useState, useMemo, useCallback, useEffect } from "react";

/*COMPONENT*/
import { Draggable } from "../reuseable";
import ProgressBar from "../common_spinner/ProgressBar";
import Modal from "../common_modal/Modal";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import {
  run_flood_from_dem,
  flood_3d,
  set_flood_default,
  set_level_flood,
  delete_polygon_flood,
} from "../../App/actions/flood_generation";
import { set_value_genangan } from "../../App/actions/genangan_actions";
import { genangan_update } from "../../App/actions/flood_generation";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import FLOOD_SLIDER from "./FLOOD_SLIDER";

/*CONST*/

const FLOOD_NEW = ({
  //variable
  auth,
  properties,
  layer,
  loading_reducer,
  genangan_reducer,

  //function
  set_value_properties,
  run_flood_from_dem,
  flood_3d,
  set_flood_default,
  set_level_flood,
  delete_polygon_flood,
  set_value_genangan,
  genangan_update,
}) => {
  const [state, setState] = useState({
    modal_delete: false,
    modal_warn: false,
    modal_edit_level_cm: false,
    modal_delete_flood: false,
    modal_debug: false,
    level_cm: 0,
    polygon_flood_feature_key_state: "",
    mode_menu: "basic", //basic || 3d
  });

  //local storage
  const language = localStorage?.language || auth?.language;

  //local state
  const {
    modal_delete,
    modal_warn,
    modal_edit_level_cm,
    modal_debug,
    level_cm,
    polygon_flood_feature_key_state,
    mode_menu,
  } = state;

  //global props
  const { modal_flood_new } = properties;
  const { loading_item_array } = loading_reducer;
  const {
    total_dem,
    current_dem,
    total_calc,
    current_calc,
    flood_level_cm_editable,
    flood_level_cm,
    total_radius_meters,
    total_batches,
  } = genangan_reducer;

  //variables
  const geo_layer = useMemo(() => {
    const { layer_id, geo_layer_list } = layer;
    return geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
      ?.geo_layer;
  }, [layer]);
  const side_table_object = geo_layer?.side_table_object || {};
  const flood_level_field = side_table_object?.flood_level_field;
  const flood_result_area_field = side_table_object?.flood_result_area_field;
  const {
    image_fields: img_field_keys = [],
    shown_fields: shown_field_keys = [],
  } = side_table_object;
  const fields = geo_layer?.fields || [];
  const image_fields = fields.filter((item) =>
    img_field_keys.includes(item?.key)
  );
  const shown_fields = fields.filter((item) =>
    shown_field_keys.includes(item?.key)
  );
  const feature_object_selected = layer?.feature_object_selected || {};
  const { years_count, months_count, days_count } = feature_object_selected;
  const point_flood_feature_key = feature_object_selected?.key;

  const polygon_flood_feature_key =
    feature_object_selected?.properties?.polygon_flood_feature_key;

  //flood result already on database
  const features_flood_all = geo_layer?.features_flood_all || [];
  const features_flood = features_flood_all.filter(
    (item) =>
      item?.properties?.point_flood_feature_key === point_flood_feature_key
  );

  // eslint-disable-next-line no-unused-vars
  const on_cinematic = () => {
    const { map_object } = layer;

    const initialZoom = map_object.getZoom();
    const initialBearing = map_object.getBearing();
    const initialPitch = map_object.getPitch();

    let animationId;
    const timeouts = [];
    let rotationSpeed = 0.15;
    let isAccelerating = true;
    let tiltPhase = 0;
    let tiltAmplitude = 5;

    const cinematicEase = (t) => {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };

    const rotate = () => {
      if (isAccelerating) {
        rotationSpeed = Math.min(rotationSpeed + 0.01, 0.9);
      } else {
        rotationSpeed = Math.max(rotationSpeed - 0.006, 0.15);
      }

      const currentBearing = map_object.getBearing();
      const newBearing = (currentBearing + rotationSpeed) % 360;

      const time = Date.now() / 1000;
      const tiltWave = Math.sin(time * 0.7 + tiltPhase) * tiltAmplitude;
      const basePitch = map_object.getPitch();
      const targetPitch = Math.max(
        0,
        Math.min(65, basePitch + tiltWave * 0.08)
      );

      map_object.flyTo({
        bearing: newBearing,
        pitch: targetPitch,
        duration: 0,
        essential: true,
        easing: (t) => t,
      });

      animationId = requestAnimationFrame(rotate);
    };

    map_object.flyTo({
      pitch: 55,
      duration: 2000,
      easing: cinematicEase,
    });

    timeouts.push(
      setTimeout(() => {
        tiltAmplitude = 4;
      }, 1000)
    );

    timeouts.push(
      setTimeout(() => {
        isAccelerating = true;
        tiltPhase = Math.PI / 3;
        tiltAmplitude = 6;
      }, 2000)
    );

    timeouts.push(
      setTimeout(() => {
        map_object.flyTo({
          zoom: initialZoom - 10,
          pitch: 50,
          duration: 3000,
          easing: cinematicEase,
        });
        tiltAmplitude = 8;
      }, 3500)
    );

    timeouts.push(
      setTimeout(() => {
        isAccelerating = false;
        tiltPhase = Math.PI / 2;
      }, 6000)
    );

    timeouts.push(
      setTimeout(() => {
        map_object.flyTo({
          zoom: initialZoom - 2,
          pitch: 65,
          duration: 2500,
          easing: cinematicEase,
        });
        tiltAmplitude = 7;
      }, 8000)
    );

    timeouts.push(
      setTimeout(() => {
        map_object.flyTo({
          zoom: initialZoom + 3,
          pitch: 60,
          duration: 2000,
          easing: cinematicEase,
        });
        tiltAmplitude = 5;
      }, 10500)
    );

    timeouts.push(
      setTimeout(() => {
        isAccelerating = false;
        tiltPhase = 0;
        tiltAmplitude = 3;
        map_object.flyTo({
          zoom: initialZoom,
          pitch: 35,
          duration: 2500,
          easing: cinematicEase,
        });
      }, 13000)
    );

    animationId = requestAnimationFrame(rotate);

    return {
      stop: () => {
        cancelAnimationFrame(animationId);
        timeouts.forEach(clearTimeout);
        map_object.flyTo({
          pitch: initialPitch,
          bearing: initialBearing,
          zoom: initialZoom,
          duration: 1000,
        });
      },
    };
  };

  const on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    set_value_genangan({
      key: name,
      value: value,
    });
  };

  const set_mode_menu = useCallback((mode_menu) => {
    setState((prev) => ({
      ...prev,
      mode_menu,
    }));
  }, []);

  const on_change_flood_level = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    set_value_genangan({
      key: name,
      value: value,
    });

    const nearest_feature_mdpl_meter =
      genangan_reducer.nearest_feature_mdpl_meter;

    const flood_level_mdpl_meter =
      Number(nearest_feature_mdpl_meter) + Number(value) / 100;

    set_value_genangan({
      key: "flood_level_mdpl_meter_editable",
      value: flood_level_mdpl_meter,
    });
  };

  useEffect(() => {
    if (point_flood_feature_key) {
      let polygon_key_active_array =
        genangan_reducer?.polygon_key_active_array || [];
      polygon_key_active_array.push(point_flood_feature_key);
      set_value_genangan({
        key: "polygon_key_active_array",
        value: polygon_key_active_array,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feature_object_selected?.key, modal_flood_new]);

  const on_close_modal = () => {
    set_value_properties({
      key: "modal_flood_new",
      value: false,
    });
  };

  const toggle_debug = useCallback(() => {
    setState((prev) => ({
      ...prev,
      modal_debug: !prev.modal_debug,
    }));
  }, []);

  const toggle_warn = useCallback(() => {
    setState((prev) => ({
      ...prev,
      modal_warn: !prev.modal_warn,
    }));
  }, []);

  const toggle_delete = useCallback((key) => {
    setState((prev) => ({
      ...prev,
      modal_delete: !prev.modal_delete,
      polygon_flood_feature_key_state: key,
    }));
  }, []);

  const on_delete_polygon_flood = useCallback(() => {
    setState((prev) => ({
      ...prev,
      modal_delete: false,
    }));

    delete_polygon_flood({
      polygon_flood_feature_key: polygon_flood_feature_key_state,
    });
  }, [delete_polygon_flood, polygon_flood_feature_key_state]);

  const on_run_flood_from_dem = () => {
    /*
    type_2: "banjir" (constant)
    point_flood_long
    point_flood_lat
    point_flood_layer_id
    point_flood_feature_key
    flood_level_cm
    flood_area_m_square
    date_run
    */

    const type_2 = "banjir";
    const point_flood_long =
      feature_object_selected?.geometry?.coordinates?.[0];
    const point_flood_lat = feature_object_selected?.geometry?.coordinates?.[1];
    const point_flood_layer_id = geo_layer?._id;
    const point_flood_feature_key = feature_object_selected?.key;
    const flood_level_cm =
      feature_object_selected?.properties?.[flood_level_field];
    const flood_area_m_square = 0;
    const date_run = Date.now();

    const body = {
      type_2,
      point_flood_long,
      point_flood_lat,
      point_flood_layer_id,
      point_flood_feature_key,
      flood_level_cm,
      flood_area_m_square,
      date_run,
      flood_result_area_field,
      is_use_editable: false,
    };

    run_flood_from_dem(body);
  };

  const save_3d = () => {
    set_mode_menu("basic");
    /*
    type_2: "banjir" (constant)
    point_flood_long
    point_flood_lat
    point_flood_layer_id
    point_flood_feature_key
    flood_level_cm
    flood_area_m_square
    date_run
    */

    const type_2 = "banjir";
    const point_flood_long =
      feature_object_selected?.geometry?.coordinates?.[0];
    const point_flood_lat = feature_object_selected?.geometry?.coordinates?.[1];
    const point_flood_layer_id = geo_layer?._id;
    const point_flood_feature_key = feature_object_selected?.key;
    const flood_level_cm =
      feature_object_selected?.properties?.[flood_level_field];
    const flood_area_m_square = 0;
    const date_run = Date.now();

    const body = {
      type_2,
      point_flood_long,
      point_flood_lat,
      point_flood_layer_id,
      point_flood_feature_key,
      flood_level_cm,
      flood_area_m_square,
      date_run,
      flood_result_area_field,
      is_use_editable: true,
    };

    run_flood_from_dem(body);
  };

  const on_flood_3d = () => {
    /*
    type_2: "banjir" (constant)
    point_flood_long
    point_flood_lat
    point_flood_layer_id
    point_flood_feature_key
    flood_level_cm
    flood_area_m_square
    date_run
    */

    const type_2 = "banjir";
    const point_flood_long =
      feature_object_selected?.geometry?.coordinates?.[0];
    const point_flood_lat = feature_object_selected?.geometry?.coordinates?.[1];
    const point_flood_layer_id = geo_layer?._id;
    const point_flood_feature_key = feature_object_selected?.key;
    const flood_level_cm =
      feature_object_selected?.properties?.[flood_level_field];
    const flood_area_m_square = 0;
    const date_run = Date.now();

    const body = {
      type_2,
      point_flood_long,
      point_flood_lat,
      point_flood_layer_id,
      point_flood_feature_key,
      flood_level_cm,
      flood_area_m_square,
      date_run,
      flood_result_area_field,
    };

    flood_3d(body);
  };

  const on_set_level_flood = useCallback(() => {
    setState((prev) => ({
      ...prev,
      modal_edit_level_cm: false,
    }));
    set_level_flood(level_cm);
  }, [level_cm, set_level_flood]);

  const on_set_flood_default = ({
    polygon_flood_feature_key,
    flood_area_m_square,
    flood_level_cm,
  }) => {
    set_flood_default({
      polygon_flood_feature_key,
      flood_area_m_square,
      flood_level_cm,
    });
  };

  const toggle_edit_level = useCallback(() => {
    setState((prev) => ({
      ...prev,
      modal_edit_level_cm: !prev.modal_edit_level_cm,
      level_cm: feature_object_selected?.properties?.[flood_level_field],
    }));
  }, [feature_object_selected?.properties, flood_level_field]);

  const on_change_level = useCallback((event) => {
    setState((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  }, []);

  const text_container = (
    <section
      className="container background_white"
      style={{
        maxHeight: "200px",
        overflowY: "auto",
      }}
    >
      {shown_fields.map((field) => (
        <div key={field.key} className="margin_bottom">
          <p className="text_small sub_color">{field?.name}</p>
          {field.key === flood_level_field ? (
            <>
              <br />
              <span className="badge_small grey_container margin_right">
                {feature_object_selected?.properties?.[field?.key] || "-"}
              </span>
              <button
                className="button_small background_black"
                onClick={toggle_edit_level}
              >
                Edit
              </button>
            </>
          ) : (
            <p className="text_medium">
              {feature_object_selected?.properties?.[field?.key] || "-"}
            </p>
          )}
        </div>
      ))}
    </section>
  );
  const has_image = image_fields.length > 0;
  const final_container = has_image ? (
    <div className="two_container_flex">
      <section>
        <div
          className="margin_bottom"
          style={{
            width: "99px",
            height: "67px",
            borderRadius: "11px",
            cursor: "pointer",
            backgroundImage: `url(${feature_object_selected?.properties?.[image_fields[0].key]
              })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <button
          className="button_small background_black"
          onClick={() => {
            set_mode_menu("3d");
            set_value_genangan({
              key: "visibility_extrude",
              value: "visible",
            });
            set_value_genangan({
              key: "visibility_flood",
              value: "none",
            });
          }}
        >
          Visualisasi 3D
        </button>
      </section>
      {text_container}
    </div>
  ) : (
    text_container
  );
  const is_future = days_count < 0 || months_count < 0 || years_count < 0;

  let content_render;

  if (mode_menu === "basic") {
    content_render = (
      <main>
        <section className="container background_grey_light margin_bottom">
          <div className="two_container_flex margin_bottom">
            <p className="badge_small yellow_container">Algoritma Genangan</p>
            <div className="text_right">
              {years_count === 0 && months_count === 0 && days_count === 0 ? (
                <div className="badge_small background_white margin_left">
                  {dict?.["Today"]?.[language]}
                </div>
              ) : (
                <div className="badge_small background_white margin_left">
                  {Math.abs(years_count) > 0 && (
                    <>
                      {Math.abs(years_count)} {dict?.["years"]?.[language]}{" "}
                    </>
                  )}
                  {Math.abs(months_count) > 0 && (
                    <>
                      {Math.abs(months_count)} {dict?.["months"]?.[language]}{" "}
                    </>
                  )}
                  {Math.abs(days_count) > 0 && (
                    <>
                      {Math.abs(days_count)} {dict?.["days"]?.[language]}{" "}
                    </>
                  )}
                  {is_future
                    ? dict?.["left"]?.[language]
                    : dict?.["ago"]?.[language]}
                </div>
              )}
            </div>
          </div>

          {final_container}

          <section className="margin_top">
            <div className="container background_white margin_bottom">
              <ProgressBar
                current_number={current_dem}
                total_number={total_dem}
                name="Akses DEM dari server"
                is_hide_count={true}
                is_loading={loading_item_array.includes("get_dem_by_centroid")}
                color="#000"
              />
              <ProgressBar
                current_number={current_calc}
                total_number={total_calc}
                name="Melakukan kalkulasi"
                is_hide_count={true}
                is_loading={loading_item_array.includes(
                  "generate_geojson_flood"
                )}
                color="#000"
              />
            </div>
            <button
              className="button_big background_black"
              onClick={on_run_flood_from_dem}
            >
              Jalankan Algoritma Genangan
            </button>
          </section>
        </section>

        <section className="container background_grey_light">
          <p className="text_small sub_color margin_bottom">
            Ada {features_flood.length} poligon area banjir tersimpan di titik
            laporan ini
          </p>
          {features_flood.map((item, idx) => {
            return (
              <div
                key={idx}
                className="two_container_flex container background_white margin_bottom"
              >
                <div>
                  <p className="text_small sub_color">
                    Ketinggian genangan (cm)
                  </p>
                  <p className="text_medium margin_bottom">
                    {new Intl.NumberFormat("id-ID", {
                      style: "decimal",
                    }).format(item?.properties?.flood_level_cm)}
                  </p>
                  <p className="text_small sub_color">Luas hasil area (m²)</p>
                  <p className="text_medium margin_bottom">
                    {new Intl.NumberFormat("id-ID", {
                      style: "decimal",
                    }).format(item?.properties?.flood_area_m_square)}
                  </p>
                </div>
                <div className="text_right">
                  {polygon_flood_feature_key === item?.key ? (
                    <div className="badge_small green_container margin_bottom">
                      Terpilih
                    </div>
                  ) : (
                    <button
                      className="button_small background_black margin_bottom"
                      onClick={() =>
                        on_set_flood_default({
                          polygon_flood_feature_key: item?.key,
                          flood_area_m_square:
                            item?.properties?.flood_area_m_square,
                          flood_level_cm: item?.properties?.flood_level_cm,
                        })
                      }
                    >
                      Jadikan default
                    </button>
                  )}
                  <br />
                  <button
                    className="button_small background_red"
                    onClick={() => toggle_delete(item?.key)}
                  >
                    Hapus
                  </button>
                </div>
              </div>
            );
          })}
        </section>
      </main>
    );
  } else {
    content_render = (
      <main>
        <section className="container background_grey_light margin_bottom">
          <h1 className="text_bold margin_bottom">Visualisasi 3D</h1>
          <button
            className="button_small background_black"
            onClick={() => {
              set_mode_menu("basic");
              set_value_genangan({
                key: "visibility_extrude",
                value: "none",
              });
              set_value_genangan({
                key: "visibility_flood",
                value: "visible",
              });
            }}
          >
            Kembali
          </button>
          <section className="margin_top">
            <div className="container background_white margin_bottom">
              <ProgressBar
                current_number={current_dem}
                total_number={total_dem}
                name="Akses DEM dari server"
                is_hide_count={true}
                is_loading={loading_item_array.includes("get_dem_by_centroid")}
                color="#000"
              />
              <div className="two_container_equal">
                {loading_item_array.includes("get_dem_by_centroid") ? (
                  <button className="button background_grey">Atur DEM</button>
                ) : (
                  <button
                    className="button background_black"
                    onClick={toggle_debug}
                  >
                    Atur DEM
                  </button>
                )}

                {loading_item_array.includes("get_dem_by_centroid") ? (
                  <button className="button background_grey">Reset</button>
                ) : (
                  <button
                    className="button background_black"
                    onClick={() => {
                      set_value_genangan({
                        key: "current_dem",
                        value: 0,
                      });
                      set_value_genangan({
                        key: "geojson_grid_elevation",
                        value: {
                          type: "FeatureCollection",
                          features: [],
                        },
                      });
                      set_value_genangan({
                        key: "geojson_flood_square",
                        value: {
                          type: "FeatureCollection",
                          features: [],
                        },
                      });
                      set_value_genangan({
                        key: "flood_level_cm_editable",
                        value: 0,
                      });
                      set_value_genangan({
                        key: "flood_level_mdpl_meter_editable",
                        value: 0,
                      });
                      genangan_update();
                    }}
                  >
                    Reset
                  </button>
                )}

                {/* <button
                  className="button background_black"
                  onClick={on_cinematic}
                >
                  Cinematic
                </button> */}
              </div>
            </div>

            {loading_item_array.includes("get_dem_by_centroid") ? (
              <div className="button_big background_grey">Memuat DEM ...</div>
            ) : (
              <button
                className="button_big background_black"
                onClick={on_flood_3d}
              >
                Lihat 3D
              </button>
            )}

            <br />
          </section>
        </section>

        {Number(current_dem) >= Number(total_dem) &&
          !loading_item_array.includes("get_dem_by_centroid") && (
            <>
              <section className="container background_grey_light margin_bottom">
                <p className="text_bold margin_bottom_extra">
                  Simulasi ketinggian banjir
                </p>
                <FLOOD_SLIDER
                  min={0}
                  max={200}
                  step={5}
                  name="flood_level_cm_editable"
                  value={flood_level_cm_editable}
                  onChange={on_change_flood_level}
                />
                <br />
                <table className="table full_width">
                  <tbody>
                    <tr>
                      <td>Ketinggian laporan</td>
                      <td>Ketinggian simulasi</td>
                    </tr>
                    <tr>
                      <td>{flood_level_cm} cm</td>
                      <td>{flood_level_cm_editable} cm</td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section className="container background_grey_light margin_bottom">
                <button
                  className="button_big background_black margin_bottom"
                  onClick={save_3d}
                >
                  Hitung Luas & Simpan
                </button>
              </section>

              <section className="two_container_auto container background_grey_light">
                <button
                  className="button_big button_white"
                  onClick={() => {
                    set_value_genangan({
                      key: "enlarge_extrude",
                      value: 1,
                    });
                  }}
                >
                  1:1 (Original)
                </button>
                <button
                  className="button_big button_white"
                  onClick={() => {
                    set_value_genangan({
                      key: "enlarge_extrude",
                      value: 10,
                    });
                  }}
                >
                  Zoom (10x)
                </button>
              </section>
            </>
          )}
      </main>
    );
  }

  return (
    <main>
      {modal_debug && (
        <Modal
          modalSize="small"
          id="modal_debug"
          isOpen={modal_debug}
          onClose={toggle_debug}
        >
          <div className="box-body">
            <p className="text_bold">
              Lebar jangkauan DEM yang diambil (AOI persegi)
            </p>
            <input
              type="number"
              name="total_radius_meters"
              value={total_radius_meters}
              onChange={on_change}
            />
            <br />
            <br />
            <p className="text_bold">Jumlah batch pengambilan data</p>
            <input
              type="number"
              name="total_batches"
              value={total_batches}
              onChange={on_change}
            />
            <br />
            <br />
            <button
              className="button_big background_black"
              onClick={toggle_debug}
            >
              Simpan pengaturan
            </button>
          </div>
        </Modal>
      )}

      {modal_delete && (
        <Modal
          modalSize="small"
          id="modal_delete"
          isOpen={modal_delete}
          onClose={toggle_delete}
        >
          <div className="box-body">
            <section className="text_center">
              <h1 className="text_big margin_bottom_extra">
                Konfirmasi hapus poligon genangan
              </h1>
              <button
                className="button_big background_black"
                onClick={on_delete_polygon_flood}
              >
                Hapus
              </button>
            </section>
          </div>
        </Modal>
      )}

      {modal_warn && (
        <Modal
          modalSize="small"
          id="modal_warn"
          isOpen={modal_warn}
          onClose={toggle_warn}
        >
          <div className="box-body">
            <h1 className="text_big text_center">
              Tunggu algoritma selesai dijalankan
            </h1>
          </div>
        </Modal>
      )}

      {modal_edit_level_cm && (
        <Modal
          modalSize="small"
          id="modal_edit_level_cm"
          isOpen={modal_edit_level_cm}
          onClose={toggle_edit_level}
        >
          <div className="box-body">
            Edit level genangan banjir (cm)
            <input
              className="margin_bottom_extra"
              type="number"
              name="level_cm"
              value={level_cm}
              onChange={on_change_level}
            />
            <button
              className="button_big background_black"
              onClick={on_set_level_flood}
            >
              Simpan
            </button>
          </div>
        </Modal>
      )}

      {modal_flood_new && (
        <Draggable
          title="Setup algoritma genangan"
          toggle_close={() => on_close_modal()}
          style={{
            background: "#fff",
            width: "315px",
            zIndex: 1,
            maxHeight: "calc( 100vh - 70px )",
            overflowY: "auto",
          }}
          initialPosition={{
            x: 35,
            y: 15,
          }}
        >
          <div style={{ padding: "10px" }}>
            {content_render}
          </div>
        </Draggable>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
  loading_reducer: state.loading_reducer,
  genangan_reducer: state.genangan_reducer,
});

export default connect(mapStateToProps, {
  set_value_properties,
  run_flood_from_dem,
  flood_3d,
  set_flood_default,
  set_level_flood,
  delete_polygon_flood,
  set_value_genangan,
  genangan_update,
})(FLOOD_NEW);
